// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35d4c1ea","239":"48964055","453":"1f902464","455":"2baea839"}[chunkId] + ".chunk.js";
};